<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M6.68071 1.05034C6.30497 0.31505 5.69421 0.318057 5.31992 1.05034L0.152361 11.1685C-0.223382 11.9038 0.119719 12.5 0.91908 12.5L11.0815 12.5C11.8809 12.5 12.2226 11.9008 11.8483 11.1685L6.68071 1.05034ZM5.25 4.25C5.25 3.83579 5.58579 3.5 6 3.5C6.41421 3.5 6.75 3.83579 6.75 4.25V7.25C6.75 7.66421 6.41421 8 6 8C5.58579 8 5.25 7.66421 5.25 7.25V4.25ZM5.25 10.25C5.25 9.83579 5.58579 9.5 6 9.5C6.41421 9.5 6.75 9.83579 6.75 10.25C6.75 10.6642 6.41421 11 6 11C5.58579 11 5.25 10.6642 5.25 10.25Z"
    fill="currentColor"
  />
</template>
